$(document).on('change', '[data-budget-update]', function() {
  const data = new FormData();
  data.append('csrfmiddlewaretoken', $('meta[name="csrf-token"]').attr('content'));
  data.append('forecast', parseFloat($(this).val()) || 0);
  $.ajax({
    url: $(this).attr('data-budget-update'),
    data,
    method: 'post',
    contentType: false,
    processData: false,
  }).then((html) => {
    const focusedElement = document.activeElement;
    const newEl = $('[data-budget]').html(html).find(`#${focusedElement.id}`);
    if (newEl.length) {
      newEl.replaceWith(focusedElement);
      focusedElement.focus();
    }
  });
});

$(document).on('change', '[data-sponsor-budget-toggle]', function() {
  const data = new FormData();
  data.append('csrfmiddlewaretoken', $('meta[name="csrf-token"]').attr('content'));
  data.append('show', this.checked ? '1' : '0');
  $.ajax({
    url: $(this).attr('data-sponsor-budget-toggle'),
    data,
    method: 'post',
    processData: false,
    contentType: false,
  });
});
